import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { date, notEmpty } from '@crehana/utils';
import { TCustomFieldTypeEnum, TSegmentationDataTypeEnum } from "./types";
var alphabeticSegmentationType = [TSegmentationDataTypeEnum.Country, TSegmentationDataTypeEnum.Gender, TSegmentationDataTypeEnum.Headquarter, TSegmentationDataTypeEnum.Position, TSegmentationDataTypeEnum.PositionCategory];
export var getFormType = function getFormType(values) {
  if (!values) {
    return undefined;
  }
  if (values.dataType !== TSegmentationDataTypeEnum.CustomField) {
    return undefined;
  }
  return values.formType;
};
export var getCategory = function getCategory(values) {
  if (!values) {
    return 'alphabetic';
  }
  var dataType = values.dataType;
  if (dataType === TSegmentationDataTypeEnum.CustomField && values.formType) {
    var stringFormType = values.formType.toString();
    if (stringFormType === TCustomFieldTypeEnum.Date.toString()) {
      return 'date';
    }
    if (stringFormType === TCustomFieldTypeEnum.Number.toString()) {
      return 'numeric';
    }
    return 'alphabetic';
  }
  if (dataType && alphabeticSegmentationType.includes(dataType)) {
    return 'alphabetic';
  }
  if (dataType === TSegmentationDataTypeEnum.CompanyEntry) {
    return 'date';
  }

  // TODO: Give render support for area @nando
  // if (dataType === SegmentationDataTypeEnum.Area) return 'numeric';

  return 'alphabetic';
};
export function sanitizeInputValues(input) {
  return (Array.isArray(input) ? input : [input]).filter(notEmpty);
}
export function formatDateRange(from, to) {
  var fromFormatted = from ? date.format(from, 'DD-MM-YYYY') : undefined;
  var toFormatted = to && to !== from ? date.format(to, 'DD-MM-YYYY') : undefined;
  return [fromFormatted, toFormatted].filter(notEmpty);
}
export function mapStateToSegmentationCondition(state, fieldLabel) {
  var _state$availableField, _state$value3;
  if (!state.fieldId || state.category !== 'date' && !state.conditionalType) {
    return {
      isValid: false
    };
  }
  var baseData = {
    fieldId: state.fieldId,
    fieldLabel: fieldLabel,
    dataType: ((_state$availableField = state.availableFields.find(function (f) {
      return f.value === state.fieldId;
    })) === null || _state$availableField === void 0 ? void 0 : _state$availableField.dataType) || TSegmentationDataTypeEnum.CustomField
  };
  if (['alphabetic', 'numeric'].includes(state.category)) {
    var _state$value, _state$value2;
    var sanitizedInputValue = sanitizeInputValues((_state$value = state.value) === null || _state$value === void 0 ? void 0 : _state$value.input);
    var sanitizedSelectedValues = ((_state$value2 = state.value) === null || _state$value2 === void 0 ? void 0 : _state$value2.selected) || [];
    var conditionalValues = state.isTagSelect ? sanitizedSelectedValues : sanitizedInputValue;
    var data = _objectSpread(_objectSpread({}, baseData), {}, {
      formType: state.category === 'numeric' ? TCustomFieldTypeEnum.Number : state.isTagSelect ? TCustomFieldTypeEnum.Multiple : TCustomFieldTypeEnum.Text,
      values: [{
        operator: state.conditionalType,
        value: state.category === 'alphabetic' ? conditionalValues : sanitizedInputValue
      }]
    });
    return {
      data: data,
      isValid: !(data !== null && data !== void 0 && data.values.some(function (v) {
        return v.value.length === 0;
      }))
    };
  }
  if (state.category === 'date' && (_state$value3 = state.value) !== null && _state$value3 !== void 0 && _state$value3.date) {
    var _state$value$date$dat = state.value.date.dates,
      from = _state$value$date$dat.from,
      to = _state$value$date$dat.to;
    var _data = _objectSpread(_objectSpread({}, baseData), {}, {
      formType: TCustomFieldTypeEnum.Date,
      values: [{
        value: formatDateRange(from, to)
      }]
    });
    var isValid = state.value.date.tab === 'range' ? (_data === null || _data === void 0 ? void 0 : _data.values[0].value.length) === 2 : (_data === null || _data === void 0 ? void 0 : _data.values[0].value.length) === 1;
    return {
      data: _data,
      isValid: isValid
    };
  }
  return {
    isValid: false
  };
}